import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BaseRoleEntity } from '../../domain/entities/BaseRoleEntity'

/**
 * Represents a model for the BaseRole entity.
 * This class extends the BaseRoleEntity and initializes its properties using the provided dataDto.
 */
export class BaseRoleModel extends BaseRoleEntity {
  /**
   * Constructs a new BaseRoleModel instance.
   *
   * @param dataDto - An object containing the initial data for the BaseRole entity.
   * The properties of this object will be mapped to the corresponding properties of the BaseRoleModel instance.
   */
  constructor(dataDto: {}) {
    super()
    mapEntityProperties(this, dataDto)
  }
}
